const style = {
  box: {
    sx: {
      alignItems: 'center',
      display: 'flex',
      p: 2,
    },
  },
  BoxFilters: {
    sx: {
      display: 'flex',
      p: 2,
    },
  },
} as const;

export default style;
